module.exports = __webpack_public_path__ + "img/image.8780bc6b.svg";